function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 3a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1v-7h-2v6H5V5h6V3H4zm10 2h3.586l-7.293 7.293 1.414 1.414L19 6.414V10h2V3h-7v2z",
  fill: "currentColor"
});

function SvgOpenDetails(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDetails);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDNDMy40NDc3MiAzIDMgMy40NDc3MiAzIDRWMjBDMyAyMC41NTIzIDMuNDQ3NzIgMjEgNCAyMUgyMEMyMC41NTIzIDIxIDIxIDIwLjU1MjMgMjEgMjBWMTRWMTNIMTlWMTRWMTlINVY1SDEwSDExVjNIMTBINFpNMTQgNUgxNy41ODU4TDEwLjI5MjkgMTIuMjkyOUwxMS43MDcxIDEzLjcwNzFMMTkgNi40MTQyMVYxMEgyMVY0VjNIMjBIMTRWNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };